<div
  class="product-type-selector"
  [class.panel-mode]="panelMode"
  [class.compact-selected]="hideInputWhenSelected && selectedProductTypes.length > 0">
  @if (selectedProductTypes.length > 0) {
    @if (hideInputWhenSelected) {
      <span class="compact-field-label">{{ label }}</span>
    }
    <mat-chip-set class="selected-chips" aria-label="Selected product types">
      @for (pt of selectedProductTypes; track pt.id) {
        <mat-chip-row (removed)="removeProductType(pt)">
          {{ rowLabel(pt) }}
          <button matChipRemove type="button" [attr.aria-label]="'Remove ' + rowLabel(pt)">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-set>
  }

  @if (!hideInputWhenSelected || selectedProductTypes.length === 0) {
  <div class="input-container">
    <mat-form-field appearance="outline" floatLabel="always" class="full-width" subscriptSizing="dynamic">
      <mat-label>{{ label }}</mat-label>
      <input
        #searchInput
        matInput
        type="text"
        [placeholder]="loading ? loadingMessage : placeholder"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchInput($event)"
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
        (keydown)="onKeyDown($event)"
        [disabled]="loading"
        [attr.aria-busy]="loading"
        autocomplete="off"
      />
      @if (loading) {
        <mat-spinner matSuffix diameter="20" class="field-suffix-spinner"></mat-spinner>
      } @else {
        <mat-icon matSuffix>search</mat-icon>
      }
    </mat-form-field>

    @if (loading && showInlineLoadingBar) {
      <div class="field-loading-bar" role="status" aria-live="polite">
        <mat-spinner diameter="22" class="field-loading-bar__spinner"></mat-spinner>
        <span class="field-loading-bar__text">{{ loadingMessage }}</span>
      </div>
    }

    @if (dropdownOpen) {
      <div
        class="options-list"
        [class.product-type-panel]="panelMode"
        [class.product-type-dropdown]="!panelMode"
        role="listbox"
        [attr.aria-busy]="loading"
        (mouseenter)="onDropdownMouseEnter()"
        (mouseleave)="onDropdownMouseLeave()">
        @if (loading) {
          <div class="dropdown-loading" role="status" aria-live="polite">
            <mat-spinner diameter="22" class="dropdown-loading__spinner"></mat-spinner>
            <span class="dropdown-loading__text">{{ loadingMessage }}</span>
          </div>
        } @else if (loadError) {
          <div class="dropdown-empty">{{ loadError }}</div>
        } @else if (filteredProductTypes.length === 0) {
          <div class="dropdown-empty">No product types found</div>
        } @else {
          @for (pt of filteredProductTypes; track pt.id; let i = $index) {
            <div
              class="dropdown-option"
              role="option"
              [class.selected]="isSelected(pt)"
              [class.highlighted]="i === highlightedIndex"
              [attr.aria-selected]="isSelected(pt)"
              (mousedown)="$event.preventDefault()"
              (click)="toggleProductType(pt)">
              @if (isSelected(pt)) {
                <mat-icon class="check-icon">check</mat-icon>
              } @else {
                <span class="check-spacer" aria-hidden="true"></span>
              }
              <span class="option-label">{{ rowLabel(pt) }}</span>
            </div>
          }
        }
      </div>
    }
  </div>
  }
</div>
